<template>
  <ul class="files-list">
    <li v-for="file in files" :key="file.key">
      <FileLink :file="file" />
    </li>
  </ul>
</template>
<script>
import FileLink from '@/components/documents/FileLink';
export default {
  props: {
    files: {
      type: Array,
      required: true,
    },
  },
  components: {
    FileLink,
  },
};
</script>
